export default __webpack_public_path__ + "static/media/2016.b1c68cb8.webp";